import { useRef } from "react";

// ======================
// AMHARIC SOUNDS
// ======================

import am1 from "../sounds/am/call_1.mp3";
import am2 from "../sounds/am/call_2.mp3";
import am3 from "../sounds/am/call_3.mp3";
import am4 from "../sounds/am/call_4.mp3";
import am5 from "../sounds/am/call_5.mp3";
import am6 from "../sounds/am/call_6.mp3";
import am7 from "../sounds/am/call_7.mp3";
import am8 from "../sounds/am/call_8.mp3";
import am9 from "../sounds/am/call_9.mp3";
import am10 from "../sounds/am/call_10.mp3";
import am11 from "../sounds/am/call_11.mp3";
import am12 from "../sounds/am/call_12.mp3";
import am13 from "../sounds/am/call_13.mp3";
import am14 from "../sounds/am/call_14.mp3";
import am15 from "../sounds/am/call_15.mp3";
import am16 from "../sounds/am/call_16.mp3";
import am17 from "../sounds/am/call_17.mp3";
import am18 from "../sounds/am/call_18.mp3";
import am19 from "../sounds/am/call_19.mp3";
import am20 from "../sounds/am/call_20.mp3";
import am21 from "../sounds/am/call_21.mp3";
import am22 from "../sounds/am/call_22.mp3";
import am23 from "../sounds/am/call_23.mp3";
import am24 from "../sounds/am/call_24.mp3";
import am25 from "../sounds/am/call_25.mp3";
import am26 from "../sounds/am/call_26.mp3";
import am27 from "../sounds/am/call_27.mp3";
import am28 from "../sounds/am/call_28.mp3";
import am29 from "../sounds/am/call_29.mp3";
import am30 from "../sounds/am/call_30.mp3";
import am31 from "../sounds/am/call_31.mp3";
import am32 from "../sounds/am/call_32.mp3";
import am33 from "../sounds/am/call_33.mp3";
import am34 from "../sounds/am/call_34.mp3";
import am35 from "../sounds/am/call_35.mp3";
import am36 from "../sounds/am/call_36.mp3";
import am37 from "../sounds/am/call_37.mp3";
import am38 from "../sounds/am/call_38.mp3";
import am39 from "../sounds/am/call_39.mp3";
import am40 from "../sounds/am/call_40.mp3";
import am41 from "../sounds/am/call_41.mp3";
import am42 from "../sounds/am/call_42.mp3";
import am43 from "../sounds/am/call_43.mp3";
import am44 from "../sounds/am/call_44.mp3";
import am45 from "../sounds/am/call_45.mp3";
import am46 from "../sounds/am/call_46.mp3";
import am47 from "../sounds/am/call_47.mp3";
import am48 from "../sounds/am/call_48.mp3";
import am49 from "../sounds/am/call_49.mp3";
import am50 from "../sounds/am/call_50.mp3";
import am51 from "../sounds/am/call_51.mp3";
import am52 from "../sounds/am/call_52.mp3";
import am53 from "../sounds/am/call_53.mp3";
import am54 from "../sounds/am/call_54.mp3";
import am55 from "../sounds/am/call_55.mp3";
import am56 from "../sounds/am/call_56.mp3";
import am57 from "../sounds/am/call_57.mp3";
import am58 from "../sounds/am/call_58.mp3";
import am59 from "../sounds/am/call_59.mp3";
import am60 from "../sounds/am/call_60.mp3";
import am61 from "../sounds/am/call_61.mp3";
import am62 from "../sounds/am/call_62.mp3";
import am63 from "../sounds/am/call_63.mp3";
import am64 from "../sounds/am/call_64.mp3";
import am65 from "../sounds/am/call_65.mp3";
import am66 from "../sounds/am/call_66.mp3";
import am67 from "../sounds/am/call_67.mp3";
import am68 from "../sounds/am/call_68.mp3";
import am69 from "../sounds/am/call_69.mp3";
import am70 from "../sounds/am/call_70.mp3";
import am71 from "../sounds/am/call_71.mp3";
import am72 from "../sounds/am/call_72.mp3";
import am73 from "../sounds/am/call_73.mp3";
import am74 from "../sounds/am/call_74.mp3";
import am75 from "../sounds/am/call_75.mp3";

// ======================
// ENGLISH SOUNDS
// ======================

import en1 from "../sounds/en/call_1.mp3";
import en2 from "../sounds/en/call_2.mp3";
import en3 from "../sounds/en/call_3.mp3";
import en4 from "../sounds/en/call_4.mp3";
import en5 from "../sounds/en/call_5.mp3";
import en6 from "../sounds/en/call_6.mp3";
import en7 from "../sounds/en/call_7.mp3";
import en8 from "../sounds/en/call_8.mp3";
import en9 from "../sounds/en/call_9.mp3";
import en10 from "../sounds/en/call_10.mp3";
import en11 from "../sounds/en/call_11.mp3";
import en12 from "../sounds/en/call_12.mp3";
import en13 from "../sounds/en/call_13.mp3";
import en14 from "../sounds/en/call_14.mp3";
import en15 from "../sounds/en/call_15.mp3";
import en16 from "../sounds/en/call_16.mp3";
import en17 from "../sounds/en/call_17.mp3";
import en18 from "../sounds/en/call_18.mp3";
import en19 from "../sounds/en/call_19.mp3";
import en20 from "../sounds/en/call_20.mp3";
import en21 from "../sounds/en/call_21.mp3";
import en22 from "../sounds/en/call_22.mp3";
import en23 from "../sounds/en/call_23.mp3";
import en24 from "../sounds/en/call_24.mp3";
import en25 from "../sounds/en/call_25.mp3";
import en26 from "../sounds/en/call_26.mp3";
import en27 from "../sounds/en/call_27.mp3";
import en28 from "../sounds/en/call_28.mp3";
import en29 from "../sounds/en/call_29.mp3";
import en30 from "../sounds/en/call_30.mp3";
import en31 from "../sounds/en/call_31.mp3";
import en32 from "../sounds/en/call_32.mp3";
import en33 from "../sounds/en/call_33.mp3";
import en34 from "../sounds/en/call_34.mp3";
import en35 from "../sounds/en/call_35.mp3";
import en36 from "../sounds/en/call_36.mp3";
import en37 from "../sounds/en/call_37.mp3";
import en38 from "../sounds/en/call_38.mp3";
import en39 from "../sounds/en/call_39.mp3";
import en40 from "../sounds/en/call_40.mp3";
import en41 from "../sounds/en/call_41.mp3";
import en42 from "../sounds/en/call_42.mp3";
import en43 from "../sounds/en/call_43.mp3";
import en44 from "../sounds/en/call_44.mp3";
import en45 from "../sounds/en/call_45.mp3";
import en46 from "../sounds/en/call_46.mp3";
import en47 from "../sounds/en/call_47.mp3";
import en48 from "../sounds/en/call_48.mp3";
import en49 from "../sounds/en/call_49.mp3";
import en50 from "../sounds/en/call_50.mp3";
import en51 from "../sounds/en/call_51.mp3";
import en52 from "../sounds/en/call_52.mp3";
import en53 from "../sounds/en/call_53.mp3";
import en54 from "../sounds/en/call_54.mp3";
import en55 from "../sounds/en/call_55.mp3";
import en56 from "../sounds/en/call_56.mp3";
import en57 from "../sounds/en/call_57.mp3";
import en58 from "../sounds/en/call_58.mp3";
import en59 from "../sounds/en/call_59.mp3";
import en60 from "../sounds/en/call_60.mp3";
import en61 from "../sounds/en/call_61.mp3";
import en62 from "../sounds/en/call_62.mp3";
import en63 from "../sounds/en/call_63.mp3";
import en64 from "../sounds/en/call_64.mp3";
import en65 from "../sounds/en/call_65.mp3";
import en66 from "../sounds/en/call_66.mp3";
import en67 from "../sounds/en/call_67.mp3";
import en68 from "../sounds/en/call_68.mp3";
import en69 from "../sounds/en/call_69.mp3";
import en70 from "../sounds/en/call_70.mp3";
import en71 from "../sounds/en/call_71.mp3";
import en72 from "../sounds/en/call_72.mp3";
import en73 from "../sounds/en/call_73.mp3";
import en74 from "../sounds/en/call_74.mp3";
import en75 from "../sounds/en/call_75.mp3";

// ======================
// OROMO SOUNDS
// ======================


import or1 from "../sounds/or/call_1.mp3";
import or2 from "../sounds/or/call_2.mp3";
import or3 from "../sounds/or/call_3.mp3";
import or4 from "../sounds/or/call_4.mp3";
import or5 from "../sounds/or/call_5.mp3";
import or6 from "../sounds/or/call_6.mp3";
import or7 from "../sounds/or/call_7.mp3";
import or8 from "../sounds/or/call_8.mp3";
import or9 from "../sounds/or/call_9.mp3";
import or10 from "../sounds/or/call_10.mp3";
import or11 from "../sounds/or/call_11.mp3";
import or12 from "../sounds/or/call_12.mp3";
import or13 from "../sounds/or/call_13.mp3";
import or14 from "../sounds/or/call_14.mp3";
import or15 from "../sounds/or/call_15.mp3";
import or16 from "../sounds/or/call_16.mp3";
import or17 from "../sounds/or/call_17.mp3";
import or18 from "../sounds/or/call_18.mp3";
import or19 from "../sounds/or/call_19.mp3";
import or20 from "../sounds/or/call_20.mp3";
import or21 from "../sounds/or/call_21.mp3";
import or22 from "../sounds/or/call_22.mp3";
import or23 from "../sounds/or/call_23.mp3";
import or24 from "../sounds/or/call_24.mp3";
import or25 from "../sounds/or/call_25.mp3";
import or26 from "../sounds/or/call_26.mp3";
import or27 from "../sounds/or/call_27.mp3";
import or28 from "../sounds/or/call_28.mp3";
import or29 from "../sounds/or/call_29.mp3";
import or30 from "../sounds/or/call_30.mp3";
import or31 from "../sounds/or/call_31.mp3";
import or32 from "../sounds/or/call_32.mp3";
import or33 from "../sounds/or/call_33.mp3";
import or34 from "../sounds/or/call_34.mp3";
import or35 from "../sounds/or/call_35.mp3";
import or36 from "../sounds/or/call_36.mp3";
import or37 from "../sounds/or/call_37.mp3";
import or38 from "../sounds/or/call_38.mp3";
import or39 from "../sounds/or/call_39.mp3";
import or40 from "../sounds/or/call_40.mp3";
import or41 from "../sounds/or/call_41.mp3";
import or42 from "../sounds/or/call_42.mp3";
import or43 from "../sounds/or/call_43.mp3";
import or44 from "../sounds/or/call_44.mp3";
import or45 from "../sounds/or/call_45.mp3";
import or46 from "../sounds/or/call_46.mp3";
import or47 from "../sounds/or/call_47.mp3";
import or48 from "../sounds/or/call_48.mp3";
import or49 from "../sounds/or/call_49.mp3";
import or50 from "../sounds/or/call_50.mp3";
import or51 from "../sounds/or/call_51.mp3";
import or52 from "../sounds/or/call_52.mp3";
import or53 from "../sounds/or/call_53.mp3";
import or54 from "../sounds/or/call_54.mp3";
import or55 from "../sounds/or/call_55.mp3";
import or56 from "../sounds/or/call_56.mp3";
import or57 from "../sounds/or/call_57.mp3";
import or58 from "../sounds/or/call_58.mp3";
import or59 from "../sounds/or/call_59.mp3";
import or60 from "../sounds/or/call_60.mp3";
import or61 from "../sounds/or/call_61.mp3";
import or62 from "../sounds/or/call_62.mp3";
import or63 from "../sounds/or/call_63.mp3";
import or64 from "../sounds/or/call_64.mp3";
import or65 from "../sounds/or/call_65.mp3";
import or66 from "../sounds/or/call_66.mp3";
import or67 from "../sounds/or/call_67.mp3";
import or68 from "../sounds/or/call_68.mp3";
import or69 from "../sounds/or/call_69.mp3";
import or70 from "../sounds/or/call_70.mp3";
import or71 from "../sounds/or/call_71.mp3";
import or72 from "../sounds/or/call_72.mp3";
import or73 from "../sounds/or/call_73.mp3";
import or74 from "../sounds/or/call_74.mp3";
import or75 from "../sounds/or/call_75.mp3";


// ======================
// SOUND ARRAYS
// ======================

const amharicSounds = [
  am1, am2, am3, am4, am5, am6, am7, am8, am9, am10,
  am11, am12, am13, am14, am15, am16, am17, am18, am19, am20,
  am21, am22, am23, am24, am25, am26, am27, am28, am29, am30,
  am31, am32, am33, am34, am35, am36, am37, am38, am39, am40,
  am41, am42, am43, am44, am45, am46, am47, am48, am49, am50,
  am51, am52, am53, am54, am55, am56, am57, am58, am59, am60,
  am61, am62, am63, am64, am65, am66, am67, am68, am69, am70,
  am71, am72, am73, am74, am75
];

const englishSounds = [
  en1, en2, en3, en4, en5, en6, en7, en8, en9, en10,
  en11, en12, en13, en14, en15, en16, en17, en18, en19, en20,
  en21, en22, en23, en24, en25, en26, en27, en28, en29, en30,
  en31, en32, en33, en34, en35, en36, en37, en38, en39, en40,
  en41, en42, en43, en44, en45, en46, en47, en48, en49, en50,
  en51, en52, en53, en54, en55, en56, en57, en58, en59, en60,
  en61, en62, en63, en64, en65, en66, en67, en68, en69, en70,
  en71, en72, en73, en74, en75
];

const oromoSounds = [
  or1, or2, or3, or4, or5, or6, or7, or8, or9, or10,
  or11, or12, or13, or14, or15, or16, or17, or18, or19, or20,
  or21, or22, or23, or24, or25, or26, or27, or28, or29, or30,
  or31, or32, or33, or34, or35, or36, or37, or38, or39, or40,
  or41, or42, or43, or44, or45, or46, or47, or48, or49, or50,
  or51, or52, or53, or54, or55, or56, or57, or58, or59, or60,
  or61, or62, or63, or64, or65, or66, or67, or68, or69, or70,
  or71, or72, or73, or74, or75
];

// ======================
// HOOK
// ======================

export function useCallSounds(language = "am") {

  const audioRef = useRef(null);

  const playCall = (num) => {

    let sounds = amharicSounds;

    if (language === "en") {
      sounds = englishSounds;
    }

    if (language === "or") {
      sounds = oromoSounds;
    }

    if (num < 1 || num > sounds.length) {
      return;
    }

    const soundFile = sounds[num - 1];

    if (!soundFile) return;

    try {

      // Stop previous sound
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }

      // Create new audio
      audioRef.current = new Audio(soundFile);

      audioRef.current.volume = 1;

      audioRef.current.play();

    } catch (err) {
      console.log("Sound play error:", err);
    }
  };

  return { playCall };
}

// ======================
// PRELOAD ALL SOUNDS
// ======================

export const preloadAllSounds = (onProgress) => {
  return new Promise((resolve) => {

    const allSounds = [
      ...amharicSounds,
      ...englishSounds,
      ...oromoSounds,
    ];

    let loaded = 0;
    const total = allSounds.length;

    allSounds.forEach((soundSrc) => {

      const audio = new Audio();

      audio.src = soundSrc;

      audio.preload = "auto";

      audio.oncanplaythrough = () => {

        loaded++;

        const progress = Math.floor((loaded / total) * 100);

        if (onProgress) {
          onProgress(progress);
        }

        if (loaded === total) {
          resolve();
        }
      };

      audio.onerror = () => {

        loaded++;

        const progress = Math.floor((loaded / total) * 100);

        if (onProgress) {
          onProgress(progress);
        }

        console.log("Failed loading:", soundSrc);

        if (loaded === total) {
          resolve();
        }
      };
    });

  });
};